import React from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";
import DropDown from '../DropDown';

const IFrameModal = ({ url, handleCancel, showModal }) => (
    <div>
        <div className="modal" style={{display: (showModal ? 'block': '' )}}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" style={{width:'720px'}}>
                    <div className="modal-header" style={{width:'720px'}}>
                        <h5 className="modal-title"></h5>
                        <button type="button" className="close border-0 rounded-2 p-1" aria-label="Close" onClick={handleCancel}>
                            <MdClose />
                        </button>
                    </div>
                    <div className="modal-body " style={{width:'720px'}}>
                       {
                          <iframe id='fr' name="FormData" width='100%' height={1000} src ={url} allow=""></iframe>

                       }
                    </div>
                    <div className="modal-footer">
                        {/* <button type="button" className="btn btn-light-danger font-weight-bold" onClick={handleCancel}>{footerOption2 ? footerOption2 : t("sideNav.newJobRequest.close")}</button>
                        <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={handleOk}>{footerOption1 ? footerOption1 : t("sideNav.newJobRequest.ok")}
                            {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                        </button> */}
                    </div>
                </div>
            </div>

        </div>
        <div className="modal-backdrop show"></div>

 </div>

);

export default IFrameModal;